import { PWBWorker } from "promise-worker-bi";
export const promiseWorker = new PWBWorker();
